// Te plannen rail: hide redundant project pills on subtasks matching the hoofdtaak.
import { getTaskProjects } from '@/features/tasks/utils/data/taskTags';
import { getTrueRootId } from '@/features/tasks/utils/structure/taskHierarchy';

/** @param {string[]} projects */
function projectKeySet(projects) {
  return new Set(
    (projects || []).map((p) => String(p).trim().toLowerCase()).filter(Boolean),
  );
}

/** @param {Set<string>} a @param {Set<string>} b */
function projectSetsEqual(a, b) {
  if (a.size !== b.size) return false;
  for (const key of a) {
    if (!b.has(key)) return false;
  }
  return true;
}

/**
 * Te plannen rail: hide redundant project pills on subtasks that match the
 * hoofdtaak. Show the pill when the subtask project differs.
 * @param {string[]} allProjects
 * @param {{ listId?: string|null, task?: import('@/types').Task|null, tasksMap?: Map<string, import('@/types').Task>|null }} opts
 * @returns {string[]}
 */
export function resolveUnscheduledRailVisibleProjects(allProjects, opts = {}) {
  const { listId, task, tasksMap } = opts;
  const projects = allProjects || [];
  if (listId !== 'unscheduled' || !task?.parentId) {
    return projects;
  }
  if (!tasksMap?.size) {
    return [];
  }
  const rootId = getTrueRootId(task.parentId, tasksMap);
  const root = tasksMap.get(rootId);
  if (!root) {
    return [];
  }
  const rootKeys = projectKeySet(getTaskProjects(root));
  const taskKeys = projectKeySet(projects);
  if (taskKeys.size === 0 || projectSetsEqual(taskKeys, rootKeys)) {
    return [];
  }
  return projects;
}
